import { formatLastRunDate } from 'src/products/connector/utils/formatLastRunDate';
import { getSourceRunDetails } from '../getSourceRunDetails';
import { createConnectorStatusMessage } from 'src/products/connector/utils/createConnectorStatusMessage';
import { buildConnectorAllStatuses } from 'src/products/connector/utils/buildConnectorAllStatuses';
import {
  BuildConnectorStageObjectArgs,
  BuildConnectorStageObjectReturn,
} from './model';
import { getComponentRunningMessage } from '../../../connectors-landing/utils/getComponentRunningMessage';

export const buildConnectorStageObject = ({
  endDatetime,
  isRunning,
  connector,
  status,
  stage,
}: BuildConnectorStageObjectArgs): BuildConnectorStageObjectReturn => {
  const { models, sources } = connector;
  const lastRun = formatLastRunDate(endDatetime);
  const { failedConnectorComponent, connectorStatus } =
    buildConnectorAllStatuses({
      models,
      sources,
      status: status,
      stage,
    });
  const runningComponentMessage = getComponentRunningMessage({
    sources,
    models,
    statusObject: { isRunning },
  });

  const { nextRun } = getSourceRunDetails(sources);

  const connectorStatusMessage = createConnectorStatusMessage({
    connectorEndDateTime: endDatetime,
    connectorStatus,
    sources,
    failedConnectorComponent,
  });

  const connectorRunningObject = {
    isRunning: Boolean(isRunning),
    runningMessage: runningComponentMessage ?? '',
  };

  return {
    lastRun,
    status: connectorStatus,
    connectorStatusMessage,
    nextRun,
    connectorRunningObject,
    failedConnectorComponent,
  };
};
